import httpClient from "../../../custom-hooks/httpClient";

export const handleChange = (
  selectedOption,
  handleChangeTransferDetails,
  setBankAccountName,
  setTransferDetails,
  transferDetails,
) => {
  const [bankCode, bankName] = selectedOption.value.split("***");
  handleChangeTransferDetails({
    target: { name: "bank", value: bankCode },
  });
  setBankAccountName("");
  setTransferDetails({
    ...transferDetails,
    bank: `${bankCode}***${bankName}`,
    bankName: bankName,
    bank_code: bankCode,
  });
};

export const verifyAccountNumber = (
  setBankAccountName,
  setAccountDetails,
  setTransferDetails,
  transferDetails,
  setIsValidating,
  bankAccountNumber,
  beneficiaries,
  setIsExistingBeneficiary,
  toast,
) => {
  setIsValidating(true);
  setBankAccountName("");
  setAccountDetails({});
  httpClient
    .post(`/transfers/wallet-to-bank/verify-account-number`, {
      channelCode: "1",
      beneficiaryBankCode: `${transferDetails.bank_code}`,
      beneficiaryAccountNumber: `${
        bankAccountNumber || transferDetails.account_number
      }`, // Verify new account number or saved beneficiary account number.
    })
    .then(({ status, data }) => {
      if (status === 200) {
        setIsValidating(false);
        setAccountDetails(data.account);
        setBankAccountName(data.account.beneficiaryAccountName);
        setTransferDetails({
          ...transferDetails,
          account_name: data.account.beneficiaryAccountName,
        });

        // Check if the validated account number is on the beneficiaries list.
        const isBeneficiary = beneficiaries.some(
          (beneficiary) =>
            beneficiary.recipient_account_number ===
            transferDetails.account_number,
        );
        setIsExistingBeneficiary(isBeneficiary);
      }
    })
    .catch((err) => {
      setIsValidating(false);
      console.log(err);
      toast.error(
        err?.response?.data?.message || "Error verifying account number",
      );
    });
};

export const chooseBeneficiary = async (
  setBeneficiaries,
  setShowModal,
  senderAccount,
  bankOptions,
) => {
  try {
    const { data, status } = await httpClient.get(
      `/beneficiaries/${senderAccount}`,
    );
    if (status === 200) {
      for (const key in data) {
        const bankCode = data[key].bank_code;
        const bankName = bankOptions.find(
          (bank) => bank.value.split("***")[0] === bankCode,
        )?.label;
        data[key]["bankName"] = bankName;
      }
      setBeneficiaries(data.data ?? []);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setShowModal(true);
  }
};

export const beneficiarySelection = (
  beneficiary,
  setTransferDetails,
  setBankAccountName,
  setShowModal,
  setBeneficiarySelected,
  toast,
  transferDetails,
) => {
  try {
    setTransferDetails({
      ...transferDetails,
      bank: `${beneficiary.bank_code}***${beneficiary.bankName}`,
      bankName: beneficiary.bankName,
      bank_code: beneficiary.bank_code,
      account_number: beneficiary.recipient_account_number,
      account_name: beneficiary.name,
    });
    setBankAccountName(beneficiary.name); // Set bankAccountName to saved beneficiary name.
    setShowModal(false);
    setBeneficiarySelected(true); // Set beneficiarySelected to true
  } catch (error) {
    console.error(error);
    toast.error("Unable to select beneficiary. Please, try again.");
  }
};

export const areFieldsSet = (transferDetails, bankAccountNumber) => {
  const isBankSelected = !!transferDetails.bank || !!transferDetails.bankName;
  const isAccountNumberSet =
    !!bankAccountNumber || !!transferDetails.account_number;
  const isAmountSet = transferDetails.amount > 0;
  return isBankSelected && isAccountNumberSet && isAmountSet;
};

export const fetchBanks = (setBanks, toast) => {
  httpClient
    .post(`/transfers/wallet-to-bank/get-banks`, {})
    .then(({ status, data }) => {
      if (status === 200) {
        setBanks(data.bankArray);
      }
    })
    .catch((err) => {
      toast.error(err?.response?.data?.message || "Error getting banks");
    });
};

export const fetchBeneficiaries = (senderAccount, setBeneficiaries) => {
  httpClient
    .get(`/beneficiaries/${senderAccount}`)
    .then(({ status, data }) => {
      if (status === 200) {
        setBeneficiaries(data.data);
      }
    })
    .catch((err) => {
      console.error(err?.response?.data?.message ?? err.message);
    });
};
